import {RiskModel} from "@/services/ModelRisk/RiskModel";

export class RiskModelService {
    async all() {
        return await axios.get(`${RiskModel.endpoint}`)
    }
}
